import { TransactionAmount } from './TransactionAmount';
import { useTranslation } from 'react-i18next';
import { Card, Chip, Typography } from '@heroui/react';
import { NumberValue } from '@heroui-pro/react';
import type { SalesTransaction } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import {
    getCartUnitsCount,
    getDominantPaymentType,
    PAYMENT_CHIP_COLOR,
    PAYMENT_TYPE_LABEL_KEY,
} from './transactionsMeta';

type TransactionDetailStatsProps = { transaction: SalesTransaction };
export const TransactionDetailStats = ({
    transaction,
}: TransactionDetailStatsProps) => {
    const { t } = useTranslation('pages');
    const payment = getDominantPaymentType(transaction);
    return (
        <div
            className="grid grid-cols-3 gap-3"
            {...getNodeTestIdProp('transaction-detail-stats')}
        >
            <Card
                variant="secondary"
                className="items-center gap-1 p-3"
                {...getNodeTestIdProp('transaction-detail-stat-total')}
            >
                <Typography type="h4" weight="bold">
                    <span {...getNodeTestIdProp('transaction-detail-total')}>
                        <TransactionAmount
                            amountTetri={transaction.totalTetri}
                        />
                    </span>
                </Typography>
                <Typography type="body-xs" color="muted">
                    {t('sales.widgets.transactions.modal.total')}
                </Typography>
            </Card>
            <Card
                variant="secondary"
                className="items-center justify-center gap-1 p-3"
                {...getNodeTestIdProp('transaction-detail-stat-payment')}
            >
                <Chip
                    color={payment ? PAYMENT_CHIP_COLOR[payment] : 'default'}
                    variant="tertiary"
                    size="sm"
                    {...getNodeTestIdProp('transaction-detail-payment')}
                >
                    {payment ? t(PAYMENT_TYPE_LABEL_KEY[payment]) : '—'}
                </Chip>
                <Typography type="body-xs" color="muted">
                    {t('sales.widgets.transactions.modal.payment')}
                </Typography>
            </Card>
            <Card
                variant="secondary"
                className="items-center gap-1 p-3"
                {...getNodeTestIdProp('transaction-detail-stat-units')}
            >
                <Typography type="h4" weight="bold">
                    <NumberValue
                        style="decimal"
                        value={getCartUnitsCount(transaction)}
                        maximumFractionDigits={0}
                        {...getNodeTestIdProp('transaction-detail-units')}
                    />
                </Typography>
                <Typography type="body-xs" color="muted">
                    {t('sales.widgets.transactions.modal.units')}
                </Typography>
            </Card>
        </div>
    );
};
